var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 2c.872 0 1.579.707 1.579 1.579v6.842h6.842a1.579 1.579 0 0 1 0 3.158H13.58v6.842a1.579 1.579 0 0 1-3.158 0V13.58H3.58a1.579 1.579 0 1 1 0-3.158h6.842V3.58C10.421 2.707 11.128 2 12 2",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;